import {Component, EventEmitter, Inject, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {AuthService} from "../../auth.service";
import {Router} from "@angular/router";
import {DOCUMENT} from "@angular/common";
import { AccountComponent } from '../../components/account/account.component';
import { MatDialog } from '@angular/material/dialog';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

interface Notifications {
  message: string;
  time: string;
  icon: string;
  color: string;
  status: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  email : string | null | undefined
  username:string|undefined
  isNavbarCollapsed = true;
  notifications: Notifications[] = [
    {
      message: 'Please check your mail',
      time: '14 mins ago',
      icon: 'mail',
      color: 'nfc-green',
      status: 'msg-unread',
    },
    {
      message: 'New Patient Added..',
      time: '22 mins ago',
      icon: 'person_add',
      color: 'nfc-blue',
      status: 'msg-read',
    },
    {
      message: 'Your leave is approved!! ',
      time: '3 hours ago',
      icon: 'event_available',
      color: 'nfc-orange',
      status: 'msg-read',
    },
    {
      message: 'Lets break for lunch...',
      time: '5 hours ago',
      icon: 'lunch_dining',
      color: 'nfc-blue',
      status: 'msg-read',
    },
    {
      message: 'Patient report generated',
      time: '14 mins ago',
      icon: 'description',
      color: 'nfc-green',
      status: 'msg-read',
    },
    {
      message: 'Please check your mail',
      time: '22 mins ago',
      icon: 'mail',
      color: 'nfc-red',
      status: 'msg-read',
    },
    {
      message: 'Salary credited...',
      time: '3 hours ago',
      icon: 'paid',
      color: 'nfc-purple',
      status: 'msg-read',
    },
  ];

  @Output()toggledEvent:any=new EventEmitter();
  constructor(private mAuth:AngularFireAuth,
              @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private mService:AuthService,
              private readonly router:Router,
              private dialog: MatDialog) {
    this.mAuth.user.pipe(takeUntil(this._destroyed$)).subscribe((user)=>{
      console.log(user?.email)
      this.email = user?.email
    })
    const userData=JSON.parse( localStorage.getItem('userData')!)
    this.username=userData?.userName
  }

  ngOnInit(): void {
 this.toggledAction()
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  navigateToDashboard(){
    this.router.navigate(['/home/dashboard'])
  }

  toggledAction(){
    this.toggledEvent.emit('');
  }
  logout(){
    // localStorage.clear()
this.router.navigateByUrl('/logout')  }
  openAccount(){
    this.dialog.open(AccountComponent, {
      width: '800px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '85vh',
      panelClass: 'account-dialog',
      autoFocus: false
    });
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
}
